export default "__VITE_ASSET__DlC_s8A6__"